module.exports = __webpack_public_path__ + "static/media/data-destinations.e56dc21d.png";